<template>
	<span class="riskop-product">{{name}}-{{version}}</span>
</template>

<script>
export default {
  props:{
	  name: { type: String, default: 'riskop'},
	  version: { type: String, default: '1.5'}
  }
}

</script>
